import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import { Box, Tooltip } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import SaveIcon from '@mui/icons-material/Save';
import NodeStartEvent from './NodeStartEvent';
import NodeGateway from './NodeGateway';
import NodeTask from './NodeTask';
import UserTaskForm from './userTask/UserTaskForm';
import RootServiceTask from './serviceTask/RootServiceTask';
import NodeProcesso from './NodeProcesso';
import NodeSendTask from './NodeSendTask';
import RootBusinessTask from './businessTask/RootBusinessTask';
import NodeEndEvent from './NodeEndEvent';
import NodeScriptTaskRoot from './scriptTask/NodeScriptTaskRoot';
import NodeGatewayInclusive from './NodeGatewayInclusive';
import NodeCallActivity from './NodeCallActivity';

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

export default function NodeRoot(props) {
  const { open, setOpen, item, processo } = props;
  const ref = React.useRef();

  const handleClose = () => {
    setOpen(false);
  };

  function getName() {
    if (item) {
      let txt = item && item.type;
      // console.log( item );
      if (item.businessObject && item.businessObject.name) {
        txt += " - " + item.businessObject.name;
      }
      return "["+item.id+"] "+txt;
    }
    return '';
  }

  const GeraNodeTask = () => {
    
    if (item && item.type === 'bpmn:StartEvent') {
      return (<NodeStartEvent ref={ref} item={item} processo={processo} />)
    }else if (item && item.type === 'bpmn:ParallelGateway') {
      return (<NodeGateway ref={ref} item={item} processo={processo} />)
    }else if (item && item.type === 'bpmn:Task') {
      return (<NodeTask item={item} processo={processo} />)
    }else if (item && item.type === 'bpmn:UserTask') {
      return (<UserTaskForm ref={ref} item={item} processo={processo} onClose={handleClose}/>)
    }else if (item && item.type === 'bpmn:ServiceTask') {
      return (<RootServiceTask ref={ref} item={item} processo={processo} onClose={handleClose}/>)
    }else if (item && item.type === 'bpmn:Process') {
      return (<NodeProcesso ref={ref} item={item} processo={processo} onClose={handleClose}/>)
    }else if (item && item.type === 'bpmn:SendTask') {
      return (<NodeSendTask ref={ref} item={item} processo={processo} onClose={handleClose}/>)
    }else if (item && item.type === 'bpmn:ExclusiveGateway') {
      return (<NodeGateway ref={ref} item={item} processo={processo} onClose={handleClose}/>)
    }else if (item && item.type === 'bpmn:InclusiveGateway') {
      return (<NodeGatewayInclusive ref={ref} item={item} processo={processo} onClose={handleClose}/>)
    }else if (item && item.type === 'bpmn:BusinessRuleTask') {
      return (<RootBusinessTask ref={ref} item={item} processo={processo} onClose={handleClose} />)
    }else if (item && item.type === 'bpmn:EndEvent') {
      return (<NodeEndEvent ref={ref} item={item} processo={processo} />)
    }else if (item && item.type === 'bpmn:ScriptTask') {
      return (<NodeScriptTaskRoot ref={ref} item={item} processo={processo} />)
    }else if( item && item.type === 'bpmn:CallActivity'){
      return (<NodeCallActivity ref={ref} item={item} processo={processo} />)
    }
    return (<h2>NodeTask não implementado {(item && item.type)?item.type:''} </h2>)
  }

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        // TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {getName()}
            </Typography>

            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Salvar modificações">
                <IconButton 
                  size="large"
                  color="inherit"
                  // onClick={() => setTrigger(!trigger)} sx={{ p: 0 }}
                  onClick={ () => ref.current.childMethod() }
                >
                  <SaveIcon  />
                </IconButton>
              </Tooltip>
            </Box>
          </Toolbar>
        </AppBar>
        <Box
          sx={{
            marginLeft: "10px",
            marginRight: "10px",
            my: 1,
            display: "flex",
            alignItems: "center"
          }}>
            <GeraNodeTask/>
        </Box>
        
      </Dialog>
    </React.Fragment>
  );
}
